export default {
  apiKey: 'AIzaSyDDAt5Hk5FbJginokqzN5PXqFGRnTkQxTI',
  authDomain: 'morinoashi.firebaseapp.com',
  databaseURL: 'https://morinoashi.firebaseio.com',
  projectId: 'morinoashi',
  storageBucket: 'morinoashi.appspot.com',
  messagingSenderId: '641418108798',
  appId: '1:641418108798:web:714547b570eff0536c5d2f',
  measurementId: 'G-ERE9T5FXZF'
}
